import React from 'react';
import { Modal } from 'antd';
import Button from '../common/atoms/DSButton';
import DeleteIcon from '../../assets/images/delete.svg';
import CloseIcon from '../../assets/images/close.svg';

const deleteIcon = <img src={DeleteIcon} alt='delete_icon' className='modal-icon' />;
const closeIcon = <img src={CloseIcon} alt='close_icon' style={{ display: 'inline-block' }} />;

const DeleteModal = ({ visible, title, description, action }) => {
  return (
    <Modal
      visible={visible}
      centered
      bodyStyle={{
        height: '270px',
        textAlign: 'center',
      }}
      width='540px'
      onCancel={() => action('no')}
      footer={null}
      closeIcon={closeIcon}
    >
      {deleteIcon}
      <p style={{ color: '#4B5563', fontSize: '16px', fontWeight: '600' }}>{title}</p>
      <Button style={{ fontWeight: '600', color: '#2563EB' }} onClick={() => action('no')}>
        NO, CANCEL
      </Button>
      <Button onClick={() => action('yes')} type='primary' style={{ marginLeft: '20px', fontWeight: '600' }}>
        YES, DELETE
      </Button>
      <p
        style={{
          color: '#9CA3AF',
          fontSize: '12px',
          fontWeight: 600,
          marginTop: '6%',
        }}
      >
        {description}
      </p>
    </Modal>
  );
};

export default DeleteModal;